import { createBrowserRouter, Navigate } from 'react-router-dom';
import { Layout } from './components/Layout';
import { AuthGuard } from './components/AuthGuard';
import { HomePage } from './pages/HomePage';
import { ExtractionsPage } from './pages/ExtractionsPage';
import { ExtractionDetailPage } from './pages/ExtractionDetailPage';
import { PartnersPage } from './pages/PartnersPage';
import { BuildingsPage } from './pages/BuildingsPage';
import { ProductsPage } from './pages/ProductsPage';
import { SettingsPage } from './pages/SettingsPage';
import { OnboardingPage } from './pages/OnboardingPage';
import { ImportPage } from './pages/ImportPage';
import { PdfUploadPage } from './pages/PdfUploadPage';

export const router = createBrowserRouter([
  { path: '/onboarding', element: <OnboardingPage /> },
  {
    path: '/',
    element: (
      <AuthGuard>
        <Layout />
      </AuthGuard>
    ),
    children: [
      { index: true, element: <Navigate to="/calendar" replace /> },
      { path: 'calendar', element: <HomePage /> },
      { path: 'extractions', element: <ExtractionsPage /> },
      { path: 'extractions/:id', element: <ExtractionDetailPage /> },
      { path: 'import', element: <ImportPage /> },
      { path: 'pdf-upload', element: <PdfUploadPage /> },
      { path: 'partners', element: <PartnersPage /> },
      { path: 'buildings', element: <BuildingsPage /> },
      { path: 'products', element: <ProductsPage /> },
      { path: 'settings', element: <SettingsPage /> },
    ],
  },
]);
